import { store } from "..";
import { ADD_NOTIFICATION } from "../store/types";
import { deletePatient, getSameDateTransferData, bulkDeletePatients, restorePatient } from "./api/adt.api";
import { getApiErrorInfo } from "../utilis/api-error";

const deletePatientData = async (id) => {
    try {
        const res = await deletePatient(id);
        if (res && res?._id) {
            store.dispatch({
                type: ADD_NOTIFICATION,
                payload: {
                    type: "success",
                    label: "ADT deleted successfully",
                    id: "deleteADTError",
                },
            });
        }
        return res;
    } catch (e) {
        const { message } = getApiErrorInfo(e);
        store.dispatch({
            type: ADD_NOTIFICATION,
            payload: {
                type: "error",
                label: message || "Error while trying to delete ADT.",
                id: "deleteADTError",
            },
        });
    }
};

const bulkDeletePatientsData = async (ids, reason) => {
    try {
        const res = await bulkDeletePatients(ids, reason);
        if (res && res.count > 0) {
            store.dispatch({
                type: ADD_NOTIFICATION,
                payload: {
                    type: "success",
                    label: "ADT deleted successfully",
                    id: "deleteADTSuccess",
                },
            });
        }
        return res;
    } catch (e) {
        const { message } = getApiErrorInfo(e);
        store.dispatch({
            type: ADD_NOTIFICATION,
            payload: {
                type: "error",
                label: message || "Error while trying to delete ADT.",
                id: "deleteADTError",
            },
        });
    }
};

const restorePatientData = async (id) => {
    try {
        const res = await restorePatient(id);
        if (res && res?._id) {
            store.dispatch({
                type: ADD_NOTIFICATION,
                payload: {
                    type: "success",
                    label: "ADT restored successfully",
                    id: "restoreADTError",
                },
            });
        }
        return res;
    } catch (e) {
        const { message } = getApiErrorInfo(e);
        store.dispatch({
            type: ADD_NOTIFICATION,
            payload: {
                type: "error",
                label: message || "Error while trying to restore ADT.",
                id: "restoreDTError",
            },
        });
    }
};

const getSameDateTransfer = async (data = null) => {
	try {
		const res = await getSameDateTransferData(data);
		return res;
	} catch (e) {
		console.log(e);
	}
};


export {
    deletePatientData,
    bulkDeletePatientsData,
    restorePatientData,
    getSameDateTransfer
}
